"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var EsrtWaterQuality_exports = {};
__export(EsrtWaterQuality_exports, {
  EsrtWaterQuality: () => EsrtWaterQuality
});
module.exports = __toCommonJS(EsrtWaterQuality_exports);
var import_inventory_enums = require("@cartographerio/inventory-enums");
var import_topo_map = require("@cartographerio/topo-map");
var import_core = require("../../core/index.js");
const EsrtWaterQuality = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("EsrtWaterQuality"),
  title: "ESRT Water Quality",
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("EsrtWaterQuality"),
      title: "ESRT Water Quality",
      source: (0, import_core.cartographerSourceWithDefaults)({
        layerId: (0, import_topo_map.unsafeMapLayerId)("EsrtWaterQuality"),
        attribution: []
      }),
      defaultAttribute: "wildlife",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          label: "Survey",
          attributes: [
            (0, import_topo_map.teamAttr)("teamId", "Team"),
            (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
            (0, import_topo_map.timestampAttr)({
              attributeId: "timestamp",
              label: "Date/Time",
              buckets: "auto"
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Photographs",
          attributes: [(0, import_topo_map.attachmentAttr)("photographs", "Photographs")]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Plants and Wildlife",
          attributes: [
            (0, import_topo_map.enumAttr)({
              attributeId: "bankVegetation",
              label: "Bank Vegetation",
              enum: import_inventory_enums.EsrtWaterQualityBankVegetationEnum
            }),
            (0, import_topo_map.enumAttr)({
              attributeId: "invasivePlants",
              label: "Invasive Plants",
              enum: import_inventory_enums.EsrtWaterQualityInvasivePlantEnum
            }),
            (0, import_topo_map.enumAttr)({
              attributeId: "wildlife",
              label: "Wildlife",
              enum: import_inventory_enums.EsrtWaterQualityWildlifeEnum
            }),
            (0, import_topo_map.stringAttr)({
              attributeId: "outfalls",
              label: "Outfall(s)",
              buckets: [
                (0, import_topo_map.lookupBucket)(null, import_topo_map.marker.empty, "None recorded"),
                (0, import_topo_map.lookupBucket)("Active", import_topo_map.marker.fromColor("rgb(255, 128, 0)"), "Active (discharging)"),
                (0, import_topo_map.lookupBucket)("Inactive", import_topo_map.marker.fromColor("rgb(255, 255, 0)"), "Dormant (not discharging)")
              ]
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Pollution",
          attributes: [
            (0, import_topo_map.enumAttr)({
              attributeId: "pollutionSource",
              label: "Visible Sources of Pollution",
              enum: import_inventory_enums.EsrtWaterQualityPollutionSourceEnum
            }),
            (0, import_topo_map.enumAttr)({
              attributeId: "pollutionEvidence",
              label: "Evidence of Recent Pollution",
              enum: import_inventory_enums.EsrtWaterQualityPollutionEvidenceEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "River Channel",
          attributes: [
            (0, import_topo_map.enumAttr)({
              attributeId: "obstacles",
              label: "Obstacles to Fish and Flow",
              enum: import_inventory_enums.EsrtWaterQualityFlowObstacleEnum
            }),
            (0, import_topo_map.enumAttr)({
              attributeId: "riverbedComposition",
              label: "Riverbed Composition",
              enum: import_inventory_enums.EsrtWaterQualityRiverbedCompositionEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Water Quality Measurements",
          attributes: [
            (0, import_topo_map.booleanAttr)({
              attributeId: "sampleTaken",
              label: "Water Quality Tested",
              buckets: [
                (0, import_topo_map.lookupBucket)(true, import_topo_map.marker.fromColor("limegreen")),
                (0, import_topo_map.lookupBucket)(false, import_topo_map.marker.fromColor("orange")),
                (0, import_topo_map.lookupBucket)(null, import_topo_map.marker.empty)
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "temperature",
              label: "Temperature",
              unit: "C",
              decimalPlaces: 1,
              buckets: [
                (0, import_topo_map.rangeBucket)(0, 4, import_topo_map.marker.quality(6 / 6)),
                (0, import_topo_map.rangeBucket)(4, 8, import_topo_map.marker.quality(5 / 6)),
                (0, import_topo_map.rangeBucket)(8, 12, import_topo_map.marker.quality(4 / 6)),
                (0, import_topo_map.rangeBucket)(12, 16, import_topo_map.marker.quality(3 / 6)),
                (0, import_topo_map.rangeBucket)(16, 20, import_topo_map.marker.quality(2 / 6)),
                (0, import_topo_map.rangeBucket)(20, 24, import_topo_map.marker.quality(1 / 6)),
                (0, import_topo_map.rangeBucket)(24, null, import_topo_map.marker.quality(0 / 6)),
                (0, import_topo_map.lookupBucket)(null, import_topo_map.marker.empty, "-")
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "dissolvedSolids",
              label: "Dissolved Solids",
              unit: "ppm",
              decimalPlaces: 0,
              buckets: [
                (0, import_topo_map.rangeBucket)(0, 50, import_topo_map.marker.quality(6 / 6)),
                (0, import_topo_map.rangeBucket)(50, 200, import_topo_map.marker.quality(5 / 6)),
                (0, import_topo_map.rangeBucket)(200, 350, import_topo_map.marker.quality(4 / 6)),
                (0, import_topo_map.rangeBucket)(350, 500, import_topo_map.marker.quality(3 / 6)),
                (0, import_topo_map.rangeBucket)(500, 650, import_topo_map.marker.quality(2 / 6)),
                (0, import_topo_map.rangeBucket)(650, 800, import_topo_map.marker.quality(1 / 6)),
                (0, import_topo_map.rangeBucket)(800, null, import_topo_map.marker.quality(0 / 6)),
                (0, import_topo_map.lookupBucket)(null, import_topo_map.marker.empty, "-")
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "turbidity",
              label: "Turbidity",
              unit: "NTU",
              decimalPlaces: 0,
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 12, import_topo_map.marker.quality(6 / 6)),
                (0, import_topo_map.rangeBucket)(12, 40, import_topo_map.marker.quality(5 / 6)),
                (0, import_topo_map.rangeBucket)(40, 80, import_topo_map.marker.quality(4 / 6)),
                (0, import_topo_map.rangeBucket)(80, 120, import_topo_map.marker.quality(3 / 6)),
                (0, import_topo_map.rangeBucket)(120, 160, import_topo_map.marker.quality(2 / 6)),
                (0, import_topo_map.rangeBucket)(160, 240, import_topo_map.marker.quality(1 / 6)),
                (0, import_topo_map.rangeBucket)(240, null, import_topo_map.marker.quality(0 / 6)),
                (0, import_topo_map.lookupBucket)(null, import_topo_map.marker.empty, "-")
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "ammonia",
              label: "Ammonia",
              unit: "ppm",
              decimalPlaces: 1,
              buckets: [
                (0, import_topo_map.rangeBucket)(0, 0.5, import_topo_map.marker.quality(4 / 4)),
                (0, import_topo_map.rangeBucket)(0.5, 1, import_topo_map.marker.quality(3 / 4)),
                (0, import_topo_map.rangeBucket)(1, 3, import_topo_map.marker.quality(2 / 4)),
                (0, import_topo_map.rangeBucket)(3, 6, import_topo_map.marker.quality(1 / 4)),
                (0, import_topo_map.rangeBucket)(6, null, import_topo_map.marker.quality(0 / 4)),
                (0, import_topo_map.lookupBucket)(null, import_topo_map.marker.empty, "-")
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "phosphate",
              label: "Phosphates",
              unit: "ppb",
              decimalPlaces: 0,
              buckets: [
                (0, import_topo_map.rangeBucket)(0, 100, import_topo_map.marker.quality(6 / 6)),
                (0, import_topo_map.rangeBucket)(100, 200, import_topo_map.marker.quality(5 / 6)),
                (0, import_topo_map.rangeBucket)(200, 300, import_topo_map.marker.quality(4 / 6)),
                (0, import_topo_map.rangeBucket)(300, 500, import_topo_map.marker.quality(3 / 6)),
                (0, import_topo_map.rangeBucket)(500, 1e3, import_topo_map.marker.quality(2 / 6)),
                (0, import_topo_map.rangeBucket)(1e3, 2500, import_topo_map.marker.quality(1 / 6)),
                (0, import_topo_map.rangeBucket)(2500, null, import_topo_map.marker.quality(0 / 6)),
                (0, import_topo_map.lookupBucket)(null, import_topo_map.marker.empty, "-")
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "nitrate",
              label: "Nitrates",
              unit: "ppm",
              decimalPlaces: 0,
              buckets: [
                (0, import_topo_map.rangeBucket)(0, 10, import_topo_map.marker.quality(5 / 5)),
                (0, import_topo_map.rangeBucket)(10, 30, import_topo_map.marker.quality(4 / 5)),
                (0, import_topo_map.rangeBucket)(30, 60, import_topo_map.marker.quality(3 / 5)),
                (0, import_topo_map.rangeBucket)(60, 120, import_topo_map.marker.quality(2 / 5)),
                (0, import_topo_map.rangeBucket)(120, 200, import_topo_map.marker.quality(1 / 5)),
                (0, import_topo_map.rangeBucket)(200, null, import_topo_map.marker.quality(0 / 5)),
                (0, import_topo_map.lookupBucket)(null, import_topo_map.marker.empty, "-")
              ]
            })
          ]
        })
      ]
    })
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  EsrtWaterQuality
});
//# sourceMappingURL=EsrtWaterQuality.js.map
